/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tag: NonNullable<unknown> }} Tags_Add_Tag_Aria_LabelInputs */

const en_tags_add_tag_aria_label = /** @type {(inputs: Tags_Add_Tag_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add tag ${i?.tag}`)
};

const fr_tags_add_tag_aria_label = /** @type {(inputs: Tags_Add_Tag_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajouter le tag ${i?.tag}`)
};

const de_tags_add_tag_aria_label = /** @type {(inputs: Tags_Add_Tag_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Füge das Tag ${i?.tag} hinzu`)
};

const it_tags_add_tag_aria_label = /** @type {(inputs: Tags_Add_Tag_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiungi tag ${i?.tag}`)
};

const ru_tags_add_tag_aria_label = /** @type {(inputs: Tags_Add_Tag_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Добавить тег ${i?.tag}`)
};

const es_tags_add_tag_aria_label = /** @type {(inputs: Tags_Add_Tag_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Añadir etiqueta ${i?.tag}`)
};

const zh_cn2_tags_add_tag_aria_label = /** @type {(inputs: Tags_Add_Tag_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`添加标签${i?.tag}`)
};

const ja_tags_add_tag_aria_label = /** @type {(inputs: Tags_Add_Tag_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`タグ ${i?.tag} を追加`)
};

const hi_tags_add_tag_aria_label = /** @type {(inputs: Tags_Add_Tag_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`टैग ${i?.tag} जोड़ें`)
};

const pt_pt2_tags_add_tag_aria_label = /** @type {(inputs: Tags_Add_Tag_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicionar etiqueta ${i?.tag}`)
};

/**
* | output |
* | --- |
* | "Add tag {tag}" |
*
* @param {Tags_Add_Tag_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_add_tag_aria_label = /** @type {((inputs: Tags_Add_Tag_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Add_Tag_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_add_tag_aria_label(inputs)
	if (locale === "de") return de_tags_add_tag_aria_label(inputs)
	if (locale === "it") return it_tags_add_tag_aria_label(inputs)
	if (locale === "ru") return ru_tags_add_tag_aria_label(inputs)
	if (locale === "es") return es_tags_add_tag_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_add_tag_aria_label(inputs)
	if (locale === "ja") return ja_tags_add_tag_aria_label(inputs)
	if (locale === "hi") return hi_tags_add_tag_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_add_tag_aria_label(inputs)
	return en_tags_add_tag_aria_label(inputs)
});